import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import firebase from '../../firebase/firebaseConfig';

const useStyles = makeStyles({
  table: {
    minWidth: 650,
    '@media (max-width: 890px)': {
      minWidth: 0,
    },
  },
  tableHead: {
    backgroundColor: 'black',
  },
});

function createData(name, date, time, remaining) {
  return { name, date, time, remaining };
}

const AdminAttendance = () => {
  const classes = useStyles();

  const [users, setUsers] = useState([]);

  useEffect(() => {
    //Search the firestore and set a listener for any changes to the signed in users

    const unsubscribe = firebase
      .firestore()
      .collection('signed_in_users')
      .onSnapshot((querySnapshot) => {
        if (querySnapshot) {
          setUsers(querySnapshot.docs.map((doc) => doc.data()));
        }
      });

    return () => unsubscribe();
  }, [users]);
  const rows = users.map((user) =>
    createData(
      user.name,
      user.date.toDate().toDateString(),
      user.time,
      user.remaining
    )
  );

  // createData('Frozen yoghurt', 159, 6.0, 24, 4.0),
  // createData('Ice cream sandwich', 237, 9.0, 37, 4.3),
  // createData('Eclair', 262, 16.0, 24, 6.0),
  // createData('Cupcake', 305, 3.7, 67, 4.3),
  // createData('Gingerbread', 356, 16.0, 49, 3.9),
  return (
    <div>
      <h2 align='center'>Today's Check-ins</h2>
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label='simple table'>
          <TableHead className={classes.tableHead}>
            <TableRow>
              <TableCell style={{ fontWeight: 'bold', color: 'white' }}>
                Name
              </TableCell>
              <TableCell
                style={{ fontWeight: 'bold', color: 'white' }}
                align='right'
              >
                Date
              </TableCell>
              <TableCell
                style={{ fontWeight: 'bold', color: 'white' }}
                align='right'
              >
                Time
              </TableCell>
              <TableCell
                style={{ fontWeight: 'bold', color: 'white' }}
                align='right'
              >
                Remaining
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow key={row.name}>
                <TableCell component='th' scope='row'>
                  {row.name}
                </TableCell>
                <TableCell align='right'>{row.date}</TableCell>
                <TableCell align='right'>{row.time}</TableCell>
                <TableCell align='right'>{row.remaining}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default AdminAttendance;
